import { Box } from "@mui/material";
import SectionCollapsible from "../../../../common/SectionCollapsible";
import type { CollapsibleFormSectionProps } from "../../types";
import AssessmentReportEditableFields from "./EditableFields";

function AssessmentReportContainer({ open }: CollapsibleFormSectionProps) {
  return (
    <Box data-testid="writeable-assessment-report-container">
      <SectionCollapsible open={open} label="Assessment Report">
        <AssessmentReportEditableFields />
      </SectionCollapsible>
    </Box>
  );
}

export default AssessmentReportContainer;
